import { Text, Icon } from '@components/primitives';
import { FontAwesome, Ionicons } from '@expo/vector-icons';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React, { memo } from 'react';
import { View, TouchableOpacity } from 'react-native';
import styles from './styles';

type FavouriteHeaderProps = {
  isEditEnabled: boolean;
  onToggleEdit: () => void;
  showEdit: boolean;
  show: boolean;
  t: (p) => void;
};

const FavouriteHeader: React.FC<FavouriteHeaderProps> = ({ isEditEnabled, onToggleEdit, showEdit, show, t }) => {
  if (!show) return null;
  return (
    <View style={styles.container}>
      <Text variant="md-bold">{t('favourites.favSaya')}</Text>

      {showEdit && (
        <TouchableOpacity activeOpacity={0.7} onPress={onToggleEdit} style={styles.editButton}>
          {isEditEnabled ? (
            <View style={styles.buttonContainer}>
              <Icon
                as={Ionicons}
                name="checkmark-circle-sharp"
                color={colors.secondary.orchid}
                size={scale(18)}
                marginBottom="2px"
                family="ionicons"
              />
              <Text variant="sm-normal" style={styles.editText}>
                {t('favourites.simpan')}
              </Text>
            </View>
          ) : (
            <View style={styles.buttonContainer}>
              <Icon
                as={FontAwesome}
                name="edit"
                color={colors.secondary.orchid}
                size={scale(18)}
                marginBottom="2px"
                family="fontawesome"
              />
              <Text variant="sm-normal" style={styles.editText}>
                {t('favourites.ubah')}
              </Text>
            </View>
          )}
        </TouchableOpacity>
      )}
    </View>
  );
};

export default memo(FavouriteHeader);
